(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  /* ── TOC: auto-generate from H2 / H3 ── */
  document.addEventListener('DOMContentLoaded', function () {
    var body = document.getElementById('article-body');
    var tocList = document.querySelector('.article-toc__list');
    var toc = document.getElementById('article-toc');
    if (!body || !tocList) return;

    var headings = body.querySelectorAll('h2, h3');
    if (headings.length < 1) {
      if (toc) toc.style.display = 'none';
      return;
    }

    headings.forEach(function (h, i) {
      var slug = 'section-' + i + '-' + h.textContent.trim()
        .toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').substring(0, 40);
      h.id = slug;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + slug;
      a.textContent = h.textContent.trim();
      a.className = 'article-toc__link' + (h.tagName === 'H3' ? ' article-toc__link--sub' : '');
      li.appendChild(a);
      tocList.appendChild(li);
    });
  });

  /* ── Copy link ── */
  document.querySelectorAll('[data-copy-url]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = this.dataset.copyUrl;
      var self = this;
      var done = function () {
        self.classList.add('is-copied');
        setTimeout(function () { self.classList.remove('is-copied'); }, 2000);
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(done);
      } else {
        var input = document.createElement('input');
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        done();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('.site-header');
    const hamburger = document.querySelector('.site-header__hamburger');
    const drawer = document.getElementById('header-drawer');
    const drawerClose = document.querySelector('.header__drawer-close');

    // Scroll effect
    function onScroll() {
      header.classList.toggle('site-header--scrolled', window.scrollY > 40);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Open drawer
    function openDrawer() {
      drawer.classList.remove('is-closing');
      drawer.showModal();
      hamburger.setAttribute('aria-expanded', 'true');
    }

    // Close drawer (with exit animation)
    function closeDrawer() {
      drawer.classList.add('is-closing');
      hamburger.setAttribute('aria-expanded', 'false');
    }

    // Wait for animation before calling .close()
    drawer?.addEventListener('animationend', function (e) {
      if (drawer.classList.contains('is-closing') && e.animationName === 'drawer-exit') {
        drawer.classList.remove('is-closing');
        drawer.close();
      }
    });

    // Click on backdrop
    drawer?.addEventListener('click', function (e) {
      if (e.target === drawer) closeDrawer();
    });

    hamburger?.addEventListener('click', openDrawer);
    drawerClose?.addEventListener('click', closeDrawer);
  })();

  // Chat language bridge — exposes active locale for AI chat widget
  window.getChatLanguage = function () {
    return document.documentElement.lang || 'de';
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kontakt-modal"]) return;
  try {
    
  (function () {
    // ── Open any modal via [data-open-modal="id"] ─────────────────────────────
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-open-modal]');
      if (trigger) {
        e.preventDefault();
        var modal = document.getElementById(trigger.dataset.openModal + '-modal');
        if (modal && !modal.open) modal.showModal();
        return;
      }

      // ── Close via [data-modal-close] button ───────────────────────────────
      if (e.target.closest('[data-modal-close]')) {
        var modal = e.target.closest('dialog');
        if (modal) modal.close();
        return;
      }

      // ── Close kontakt-modal via backdrop click ────────────────────────────
      // Only for kontakt-modal — cart.js handles cart-drawer's backdrop.
      if (e.target.id === 'kontakt-modal') {
        e.target.close();
      }
    });

    // ── Keyboard: Enter / Space on [data-open-modal] divs ────────────────────
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var trigger = e.target.closest('[data-open-modal]');
      if (!trigger) return;
      if (trigger.tagName === 'BUTTON' || trigger.tagName === 'A') return;
      e.preventDefault();
      var modal = document.getElementById(trigger.dataset.openModal + '-modal');
      if (modal && !modal.open) modal.showModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {

    /* ── Galerie: Thumbnail-Klick tauscht Hauptbild ── */
    document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('.gallery-thumb').forEach(function (t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');
        var mainImg = document.querySelector('.product-main__img');
        if (mainImg) mainImg.src = this.dataset.src;
      });
    });

    /* ── Mengenwähler ── */
    var qtyInput = document.getElementById('quantity');
    var qtyMinus = document.querySelector('.qty-btn--minus');
    var qtyPlus  = document.querySelector('.qty-btn--plus');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10);
        if (v > 1) qtyInput.value = v - 1;
      });
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }

    /* ── Varianten-Toggle ── */
    document.querySelectorAll('.variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.variant-btn').forEach(function (b) {
          b.classList.remove('is-active');
        });
        this.classList.add('is-active');
        var input = document.getElementById('variant-input');
        if (input) input.value = this.dataset.variantId;
        var priceEl = document.querySelector('.product-main__price');
        if (priceEl) priceEl.textContent = this.dataset.price;
      });
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorte-golden-enoki"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var mainImg = document.getElementById('sd-main-img');
    var thumbs = document.querySelectorAll('.sd__thumb');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
          thumbs.forEach(function(t) { t.classList.remove('sd__thumb--active'); });
          thumb.classList.add('sd__thumb--active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorte-kraeuterseitling"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var mainImg = document.getElementById('sd-main-img');
    var thumbs = document.querySelectorAll('.sd__thumb');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
          thumbs.forEach(function(t) { t.classList.remove('sd__thumb--active'); });
          thumb.classList.add('sd__thumb--active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorte-lionsmane"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var mainImg = document.getElementById('sd-main-img');
    var thumbs = document.querySelectorAll('.sd__thumb');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
          thumbs.forEach(function(t) { t.classList.remove('sd__thumb--active'); });
          thumb.classList.add('sd__thumb--active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorte-maitake"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var mainImg = document.getElementById('sd-main-img');
    var thumbs = document.querySelectorAll('.sd__thumb');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
          thumbs.forEach(function(t) { t.classList.remove('sd__thumb--active'); });
          thumb.classList.add('sd__thumb--active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorte-pioppino"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var mainImg = document.getElementById('sd-main-img');
    var thumbs = document.querySelectorAll('.sd__thumb');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
          thumbs.forEach(function(t) { t.classList.remove('sd__thumb--active'); });
          thumb.classList.add('sd__thumb--active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorte-shiitake"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var mainImg = document.getElementById('sd-main-img');
    var thumbs = document.querySelectorAll('.sd__thumb');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
          thumbs.forEach(function(t) { t.classList.remove('sd__thumb--active'); });
          thumb.classList.add('sd__thumb--active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
